import { render, staticRenderFns } from "./IconArrowRightLong.vue?vue&type=template&id=38a3ae80"
import script from "./IconArrowRightLong.vue?vue&type=script&lang=js"
export * from "./IconArrowRightLong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports